import { connect } from 'react-redux';

import MentionList from './MentionList';

const mapStateToProps = state => ({
  users: state.users
});

export default connect(mapStateToProps)(MentionList);